import { useAtomValue as o } from "jotai";
import { useMemo as t } from "react";
import { getConfigPropertyAtomCreator as e, ConfigProperty as n } from "./index13.mjs";
const P = () => {
  const r = o(
    t(() => e(n.HOTEL_ID), [])
  ), s = o(
    t(() => e(n.HOTEL_NAME), [])
  ), E = o(
    t(
      () => e(n.PROPERTY_SIZE),
      []
    )
  ), i = o(
    t(
      () => e(n.PROPERTY_TYPE),
      []
    )
  ), T = o(
    t(
      () => e(n.SUBSCRIPTION_PLAN),
      []
    )
  ), c = o(
    t(
      () => e(n.CLIENT_BOOKING_TOKEN),
      []
    )
  ), p = o(
    t(
      () => e(n.VGS_VAULT_ID),
      []
    )
  ), O = o(
    t(
      () => e(n.VGS_ENVIRONMENT),
      []
    )
  ), _ = o(
    t(
      () => e(n.GOOGLE_HOTEL_LINK),
      []
    )
  );
  return {
    hotelId: r,
    hotelName: s,
    propertySize: E,
    propertyType: i,
    subscriptionPlan: T,
    clientBookingToken: c,
    vgsVaultId: p,
    vgsEnvironment: O,
    googleHotelLink: _
  };
};
export {
  P as useHotelConfig
};
